export default [
    {
        path: '/sample/main',
        name: 'sample/main',
        component: () => import('@/views/sample/main.vue')
    },
    {
        path: '/sample/datepicker',
        name: 'sample/datepicker',
        component: () => import('@/views/sample/picker/datepicker.vue')   
    },
    {
        path: '/sample/popLayer',
        name: 'sample/popLayer',
        component: () => import('@/views/sample/layer/dialog.vue')
    },
    {
        path: '/sample/progress',
        name: 'sample/progress',
        component: () => import('@/views/sample/prog/progress.vue')
    },
    {
        path: '/sample/chart',
        name: 'sample/chartMain',
        component: () => import('@/views/sample/chart/chart.vue')
    },
    {
        path: '/sample/paging',
        name: 'sample/paging',
        component: () => import('@/views/sample/paging/infiniteScroll.vue')
    },
    {
        path: '/sample/setZone',
        name: 'sample/setZone',
        component: () => import('@/views/sample/map/setZone.vue')
    },
    {
        path: '/sample/swiper',
        name: 'sample/swiper',
        component: () => import('@/views/sample/swiper/swiper.vue')
    },
    {
        path: '/sample/setParam',
        name: 'sample/setParam',
        component: () => import('@/views/sample/params/setParam.vue')
    },
    {
        path: '/sample/getParam/:id/:name',
        name: 'sample/getParam',
        component: () => import('@/views/sample/params/getParam.vue'),
        props: true
    },
    {
        path: '/sample/map',
        name: 'sample/map',
        component: () => import('@/views/sample/map/map.vue'),
        
    },

    {
        path: '/sampleMain',
        name: 'sampleMain',
        component: () => import('@/views/sample/samples/sampleMain.vue')
    },
    {
        path: '/utilSample',
        name: 'utilSample',
        component: () => import('@/views/sample/samples/utilSample.vue')
    },
    {
        path: '/routerSample',
        name: 'routerSample',
        component: () => import('@/views/sample/samples/routerSample.vue')
    },
    

    // {
    //     path: '/sample/samples/buttonSample',
    //     name: 'buttonSample',
    //     component: () => import('@/views/sample/samples/buttonSample.vue'),
    // },
    // {
    //     path: '/sample/samples/sampleMain',
    //     name: 'sampleMain',
    //     component: () => import('@/views/sample/samples/sampleMain.vue'),
    // },
]